import { EmergencyPowerSettingsModel } from 'src/Libs/emergency-power/models'

export const getNetStatusAsLangCode = (
  model?: EmergencyPowerSettingsModel | null,
  prefix = 'systemSettings.emergencyPower.netStatusCode'
): string => {
  if (!model) {
    return `${prefix}.unknown`
  }

  if (model.isIslandGrid) {
    return `${prefix}.isolatedOperation`
  }

  if (model.isGridConnected) {
    if (model.isGridConnected && model.deviceState?.inService) {
      return `${prefix}.inService`
    } else if (model.isGridConnected && model.deviceState?.working && model.deviceState?.connected) {
      return `${prefix}.normal`
    } else {
      return `${prefix}.error`
    }
  }

  return `${prefix}.unknown`
}
